export const LIVE_START_DELAY_SECONDS = 360;

export const groupCatalogItemsByTiming = (items, now = Date.now()) => {
  const groups = {live: [], delayed: [], upcoming: [], replay: []};
  items.forEach(original => {
    let item = original;
    const start = item.startDatetime ? new Date(item.startDatetime).getTime() : null;
    const duration = Number(item.durationSeconds);
    const scheduledSlot = item.contentType !== 'partner_video' && start && duration > 0;
    const end = scheduledSlot ? start + duration * 1000 : null;
    const inLiveWindow = scheduledSlot && start <= now && now < end;
    const playback = item.playback || {};
    const threshold = Number(playback.liveStartDelaySeconds) || LIVE_START_DELAY_SECONDS;
    const delayed = inLiveWindow && (playback.status === 'live_delayed' ||
      (playback.status === 'live_waiting_upload' && playback.hasPlaybackMaterial === false && now - start > threshold * 1000));
    if (delayed) {
      item = {...item, playback: {...playback, status: 'live_delayed'}};
      groups.delayed.push(item);
    } else if (inLiveWindow) groups.live.push(item);
    else if (start && start > now) groups.upcoming.push(item);
    else groups.replay.push(item);
  });
  ['live', 'delayed', 'upcoming'].forEach(section => groups[section].sort((a, b) => new Date(a.startDatetime) - new Date(b.startDatetime)));
  groups.replay.sort((a, b) => new Date(b.startDatetime || 0) - new Date(a.startDatetime || 0));
  return groups;
};
